import { createGlobalStyle } from "styled-components";
import { linkBorderOut, subtlePulse } from "./mixins";
import { theme } from "./theme/theme";
import { leading } from "./theme/type";

const GlobalStyle = createGlobalStyle`
:root {
      box-sizing: border-box;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      -webkit-touch-callout: none;
      -webkit-tap-highlight-color: transparent;
    }

    /* section-heading rules run past the page to the screen edge; clip (not hidden) clips without making main a scroll
       container, so sticky elements inside keep working. On the root the value would propagate to the viewport and scroll */
    main {
      overflow-x: clip;
    }

    html {
      font-family: ${theme.fonts.font.primary};
      /* 1rem = 16px on every viewport, so the fontSize tokens mean what they say; mobile sizes come from the fluid
         clamps in the type roles, not from a smaller root */
      font-size: 100%;
      font-weight: ${theme.fonts.fontWeight.normal};
      line-height: 1.5;
      /* side inset read by bands, accordion rows and the loyalty sections; a page overrides it on its wrapper */
      --gutter: ${theme.spaces.padding.large};
      /* the navbar's bottom air: StyledHeader adds it, a page that wants to meet the navbar (category Head) subtracts it */
      --header-gap: ${theme.spaces.margin.xxl};
      /* the footer's top air: the footer adds it, a page whose last band should meet the footer subtracts it */
      --footer-gap: ${theme.spaces.margin.horizontal};
      /* text colour flows down by inheritance from here; no element-level colour rules (a container sets its own colour once) */
      color: ${theme.colors.font};
      background-color: ${theme.colors.white};
    }

    /* size is inherited on purpose (containers set it, or a component takes a role); only the paragraph leading is global */
    p {
      line-height: ${leading.body};
    }

    span {
      font-weight: ${theme.fonts.fontWeight.light};
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
      margin-bottom: 0.75em;
      color: ${theme.colors.titles};
    }

    h1 {
      ${theme.type.h1}
    }
    h2 {
      ${theme.type.h2}
    }
    h3 {
      ${theme.type.h3}
    }
    h4 {
      ${theme.type.h4}
    }

    h5 {
      font-size: ${theme.fonts.fontSize.xl};

      @media (max-width: 650px) {
        font-size: ${theme.fonts.fontSize.lg};
      }
    }

    ol,
    ul {
      list-style: none;
    }

    img {
      width: 100%;
      display: block;
    }

    a {
      color: inherit;
      text-decoration: inherit;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent; //TODO: migration review

      :active,
      :focus {
        outline: 0;
      }
    }

    textarea,
    input {
      outline: none;
      border: none;
      -webkit-appearance: none;
      appearance: none;
    }


    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button,
    input[type='number'] {
      -webkit-appearance: none;
      margin: 0;
      -moz-appearance: textfield !important;
      appearance: textfield;
    }

    input:focus {
      outline: none;
    }

    button {
      background-color: transparent;
      font-family: ${theme.fonts.font.primary};
      font-size: inherit; /* the UA default (13.33px) neither scales with the root nor matches the surrounding text */
      cursor: pointer;
      border: none;

      :focus {
        border: none;
        outline: none;
      }
    }

    fieldset {
      border: none;
      border: 0;
      padding: 0;
      margin: 0;
      min-width: 0;
    }

    .point-wrapper > p {
      color: #fff;
    }

    .navbar_icon {
      height: 35px;
      width: auto;
      fill: inherit; 
      transition: all 0.5s ease-out;

      @media (max-width: 680px) {
        height: 30px;
      }

      @media (max-width: 400px) {
        height: 28px;
      }
    }

    .border__out {
      ${linkBorderOut}
    }

    .swiper-button-next,
    .swiper-button-prev {
      color: ${theme.colors.primary} !important;
      ${subtlePulse}
    }

    /* hide the arrow entirely when its direction isn't possible (first / last slide) */
    .swiper-button-disabled {
      display: none !important;
    }

    a.active {
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      z-index: -1;
      left: 0;
      right: 100%;
      bottom: 0;
      background: ${theme.colors.primary};
      height: 1px;
    }
  }

  .tooltip {
  position:relative; /* making the .tooltip span a container for the tooltip text */
}

.tooltip:before {
  content: attr(data-text); /* here's the magic */
  position:absolute;
  opacity:0;
  transition:.3s opacity;  
  
  /* vertically center */
  bottom: -100%;
  
  /* move to right */
right: 0;
  
  /* basic styles */
  width: auto;
  padding:5px;
  border-radius:3px;
  background:#fff;
  color: #000;
  text-align:center;
  text-transform: lowercase;


}
.tooltip:hover:before {
  opacity:1;
}
`;

export default GlobalStyle;
